export default "__VITE_ASSET__ad773c96__"